import type { GsEvent } from '@/lib/types';

export default function EventRegistration({ event }: { event: GsEvent }) {
  const hasVerifiedLink = Boolean(event.registration_url);

  return (
    <div className="bg-background-50 border border-background-200 border-t-4 border-t-accent-500 rounded-lg p-5 md:p-6">
      <p className="font-label uppercase tracking-widest text-xs text-foreground-500">Registration</p>
      <p className="mt-2 font-heading font-bold text-2xl text-foreground-950 leading-tight">
        {hasVerifiedLink ? 'Register with the organizer' : 'Registration details coming soon'}
      </p>
      <p className="mt-2 text-sm text-foreground-600">
        {hasVerifiedLink
          ? 'Sign-up is handled directly by the tournament organizer on their own website.'
          : 'This sample listing has no verified registration link yet. In the live site, the organizer’s official sign-up button appears right here.'}
      </p>

      {hasVerifiedLink ? (
        <a
          href={event.registration_url || '#'}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-400 text-foreground-950 font-label font-bold uppercase tracking-wider py-3 rounded-md whitespace-nowrap cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-external-link-line"></i></span>
          Register on organizer&apos;s site
        </a>
      ) : (
        <button
          type="button"
          disabled
          className="mt-4 w-full inline-flex items-center justify-center gap-2 bg-background-200 text-foreground-500 font-label font-bold uppercase tracking-wider py-3 rounded-md whitespace-nowrap cursor-not-allowed"
        >
          <span className="w-5 h-5 flex items-center justify-center"><i className="ri-time-line"></i></span>
          Registration not open
        </button>
      )}

      <p className="mt-3 text-xs text-foreground-500 flex items-start gap-1.5">
        <span className="w-4 h-4 flex items-center justify-center mt-0.5"><i className="ri-information-line"></i></span>
        We only link to an organizer&apos;s registration page once it has been verified.
      </p>
    </div>
  );
}